import { ChangeEvent, FC } from "react";

import { TextInput } from "@mantine/core";

interface EmailInCcsInputProps {
  label: string;
  onChange: (emails: string[]) => void;
  value?: string[];
}

const EmailInCcsInput: FC<EmailInCcsInputProps> = ({ label, onChange, value }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const emails = e.target.value.split(";").map((email) => email.trim());
    onChange(emails);
  };

  return (
    <TextInput
      label={label}
      placeholder="Separate emails with a semicolon"
      onChange={handleChange}
      value={(value || []).join(";")}
    />
  );
};

export default EmailInCcsInput;
